import * as React from 'react';
import Tag from 'antd/lib/tag';
import { UndoOutlined } from '@ant-design/icons';
import { antGrey, runwayColors, titleStyle } from '@/components/styles/globalStyles';

// Badge shown on the app home card header when a release is a rollback
// (summary.type === ReleaseType.Rollback). Mirrors the release status tag shape and
// uses the neutral grey rollback styling used elsewhere (e.g. the releases sidebar).
export const RollbackTag: React.FC = () => (
    <Tag
        style={{
            ...titleStyle,
            fontSize: 11,
            lineHeight: '22px',
            color: runwayColors.white,
        }}
        color={antGrey.grey7}
        icon={<UndoOutlined />}
    >
        Rollback
    </Tag>
);
